import { BaseService } from './BaseService';
import {
  CreateTaskListCommand,
  CreateTaskListRuleCommand,
  TaskListRulesQueryResult,
  TaskListsQueryResult
} from '../models/tasks';

export class TasksService extends BaseService {
  getTaskListRules = async (page: number, size: number): Promise<TaskListRulesQueryResult> => {
    const query = this.BuildQueryString({ page, size });

    const result = await this.Fetch(`/tasks/rules?${query}`, 'GET');

    return this.FromResult<TaskListRulesQueryResult>(result);
  };

  addTaskListRule = async (command: CreateTaskListRuleCommand): Promise<string> => {
    const result = await this.Fetch('/tasks/rules', 'POST', JSON.stringify(command));

    return this.FromResult<string>(result);
  };

  removeTaskListRule = async (id: string): Promise<string> => {
    const result = await this.Fetch('/tasks/rules', 'DELETE', JSON.stringify({ id }));

    return this.FromResult<string>(result);
  };

  getTaskLists = async (
    page: number,
    size: number,
    includeCompleted: boolean = true,
    assignedToMe: boolean = false
  ): Promise<TaskListsQueryResult> => {
    const query = this.BuildQueryString({ page, size, includeCompleted, assignedToMe });

    const result = await this.Fetch(`/tasks?${query}`, 'GET');

    return this.FromResult<TaskListsQueryResult>(result);
  };

  createTaskList = async (command: CreateTaskListCommand): Promise<string> => {
    const result = await this.Fetch('/tasks', 'POST', JSON.stringify(command));

    return this.FromResult<string>(result);
  };
}

export default TasksService;
